import { SubspaceId } from "../SubspaceId.js";
import { FixedLengthByteStringRange } from "./ByteStringRange.js";
export class SubspaceRange extends FixedLengthByteStringRange(SubspaceId.LENGTH, SubspaceId) {
}
//# sourceMappingURL=SubspaceRange.js.map